import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    Paper,
} from "@mui/material";

const DataTable = ({ columns, data, loading }) => {
    const flatColumns = columns.flatMap(col =>
        col.children ? col.children : [col]
    );

    const hasGroupedColumns = columns.some(col => col.children);
    return (
        <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
            <Table stickyHeader sx={{ minWidth: 800, width: "100%" }}>
                <TableHead>
                    {hasGroupedColumns && <TableRow>
                        {columns.map((col, index) => {
                            if (!col.children) {
                                return (
                                    <TableCell
                                        key={col.headerName}
                                        sx={{
                                            border: "none",
                                            background: "transparent",
                                        }}
                                    />
                                );
                            }

                            return (
                                <TableCell
                                    key={col.headerName}
                                    colSpan={col.children.length}
                                    align="center"
                                    sx={{
                                        fontWeight: 700,
                                        background: "#F6F8F9",
                                        color: "#000",
                                        borderTop: "1px solid #ccc",
                                        borderLeft: "1px solid #ccc",
                                        borderRight: "1px solid #ccc",
                                        borderBottom: "1px solid #ccc",
                                    }}
                                >
                                    {col.headerName}
                                </TableCell>
                            );
                        })}
                    </TableRow>}
                    <TableRow>
                        {columns.map((col) => {
                            if (col.children) {
                                return col.children.map((child, index) => {
                                    const isFirst = index === 0;
                                    const isLast = index === col.children.length - 1;

                                    return (
                                        <TableCell
                                            key={child.field}
                                            sx={{
                                                fontWeight: 600,
                                                whiteSpace: "nowrap",
                                                background: "#F6F8F9",

                                                borderBottom: "1px solid #ddd",
                                                borderLeft: isFirst ? "1px solid #ccc" : "none",
                                                borderRight: isLast
                                                    ? "1px solid #ccc"
                                                    : "1px solid #eee",
                                            }}
                                        >
                                            {child.headerName}
                                        </TableCell>
                                    );
                                });
                            }

                            return (
                                <TableCell
                                    key={col.field}
                                    sx={{
                                        fontWeight: 600,
                                        whiteSpace: "nowrap",
                                        background: "#F6F8F9",

                                        borderBottom: "1px solid #ddd",
                                        borderLeft: "1px solid #ddd",
                                        borderRight: "1px solid #ddd",
                                    }}
                                >
                                    {col.headerName}
                                </TableCell>
                            );
                        })}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((row, rowIndex) => (
                        <TableRow key={rowIndex}>
                            {flatColumns.map((col, colIndex) => (
                                <TableCell
                                    key={col.field}
                                    sx={{
                                        whiteSpace: "nowrap",
                                        borderBottom: "1px solid #eee",
                                        borderLeft: colIndex === 0 ? "1px solid #ddd" : "none",
                                        borderRight:
                                            colIndex === flatColumns.length - 1
                                                ? "1px solid #ddd"
                                                : "none",
                                    }}
                                >
                                    {row[col.field]}
                                </TableCell>
                            ))}
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default DataTable;